import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '../lib/auth/AuthProvider';
import { isSuperAdmin } from '../lib/team';
import { FullPageSpinner } from './ui';

/**
 * Guarda del panel Super Admin (`/admin/*`).
 * - Cargando sesión → spinner.
 * - Sin sesión → /login (guardando destino).
 * - Autenticado pero NO super admin (usuario de empresa) → a la home de empresa.
 */
export function AdminRoute() {
  const { status, user } = useAuth();
  const location = useLocation();

  if (status === 'loading') return <FullPageSpinner />;
  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (!isSuperAdmin(user?.role)) {
    return <Navigate to="/inicio" replace />;
  }
  return <Outlet />;
}

/**
 * Guarda de las rutas de empresa: si el usuario es super admin lo mandamos a su
 * panel (`/admin`). Así el login de un super admin aterriza en /admin aunque
 * PublicOnlyRoute lo devuelva a "/".
 */
export function CompanyOnlyRoute() {
  const { user } = useAuth();
  if (isSuperAdmin(user?.role)) {
    return <Navigate to="/admin" replace />;
  }
  return <Outlet />;
}
